import { CheckCircleOutlined, DeploymentUnitOutlined, InboxOutlined, LineChartOutlined } from "@ant-design/icons";

import { useTranslation } from "react-i18next";

const ICONS = {
  revenue: { icon: <LineChartOutlined />, color: "#2563eb", bg: "#e0edff" },
  shipments: { icon: <InboxOutlined />, color: "#7c3aed", bg: "#ede9fe" },
  delivered: { icon: <CheckCircleOutlined />, color: "#16a34a", bg: "#dcfce7" },
  destination: { icon: <DeploymentUnitOutlined />, color: "#0891b2", bg: "#cffafe" },
};

const Revenue = ({ data }) => console.log("data:", data);
const KpiCards = ({ items }) => {
  // ชื่อ KPI แปลที่นี่ไม่ใช่ใน adapter — adapter ต้องเป็น reference คงที่ (ดู useDashboardSection)
  // ผูกกับ `item.key` ที่ adapter กำหนด · ไม่มีคีย์แปล → ใช้ชื่ออังกฤษเดิมจาก adapter
  const { t } = useTranslation("dashboard");

  return (
    <div className="es-kpi-grid">
      {items.map((item) => {
        const meta = ICONS[item.icon] || ICONS.revenue;
        return (
          <div key={item.key || item.title} className="es-kpi-card">
            <div className="es-kpi-icon" style={{ color: meta.color, background: meta.bg }}>
              {meta.icon}
            </div>
            <div className="es-kpi-body">
              <div className="es-kpi-card-title">{t(`Kpi.${item.key}`, { defaultValue: item.title })}</div>
              <div className="es-kpi-card-value">{item.value}</div>
              {item.trend && (
                <div className={`es-kpi-card-trend ${item.positive ? "positive" : "negative"}`}>
                  {item.trend} {item.trendLabel && t("Kpi.Vs_Last_Month")}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default KpiCards;
